import React, { ReactElement, useEffect, useState } from "react";
import { Loader } from "@adeccoux/tag-ds";

import { CopilotActionSteps } from "../copilot-actions";
import { SelectFilter, SelectFilterOption } from "../../../../shared/forms";
import { toLiteral } from "../../../../../helper/locale-utils";

const SingleSelectAnswer: React.FC<any> = (props: any): ReactElement => {
  const { dialogStep, triggerAction } = props;

  const [answerOptions, setAnswerOptions] = useState<any[]>();
  const [inputValue, setInputValue] = useState<string>("");

  useEffect(() => {
    if (dialogStep?.answers) {
      const isPredefinedAnswers = Array.isArray(dialogStep?.answers);
      // If answers is already a predefined array, set it as the final options, else, fetch them
      if (isPredefinedAnswers) setAnswerOptions(dialogStep?.answers);
      else fetchAnswers(dialogStep?.answers);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dialogStep]);

  const fetchAnswers = async (answersFunction: Function) => {
    try {
      const answers = await answersFunction();
      setAnswerOptions(answers);
    } catch (e) {
      console.error(e);
      setAnswerOptions([]);
    }
  };

  const handleSelectChange = (e: any) => {
    const value = e?.target?.value;
    if (value) {
      setInputValue(value);
    }
  };

  function handleSubmit(nextStepId?: string) {
    triggerAction(inputValue, nextStepId);
  }

  const renderAnswerContainer = (_dialogStep: CopilotActionSteps, _answerOptions?: any[]) => {
    if (!_answerOptions) {
      return <Loader />;
    } else {
      return (
        <React.Fragment>
          <SelectFilter name={_dialogStep?.id} multiple={false} id={_dialogStep?.id} onChange={(e: any) => handleSelectChange(e)}>
            {_answerOptions
              ?.filter((ans) => !ans.nextStep)
              ?.map((answer: any) => (
                <SelectFilterOption key={answer?.value ?? answer?.key} value={answer?.value ?? answer?.label} label={toLiteral({ id: answer?.label })} />
              ))}
          </SelectFilter>
          <button className="button-icon ml1" disabled={!inputValue?.length} onClick={() => handleSubmit(_dialogStep?.nextStep)}>
            <span className="material-icons">send</span>
          </button>
        </React.Fragment>
      );
    }
  };

  return <div className="flex">{renderAnswerContainer(dialogStep, answerOptions)}</div>;
};

export default SingleSelectAnswer;
